export default "__VITE_ASSET__E$6VRZMX__"